import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
import es from "./es.json";
import it from "./it.json";
import pt from "./pt.json";
import af from "./af.json";
import tl from "./tl.json";
import tr from "./tr.json";
import ar from "./ar.json";

export type TranslationKeys = typeof en;

// Use type assertion to allow partial translations
export const translations: Record<string, TranslationKeys> = {
  english: en,
  french: fr as unknown as TranslationKeys,
  german: de as unknown as TranslationKeys,
  spanish: es as unknown as TranslationKeys,
  italian: it as unknown as TranslationKeys,
  portuguese: pt as unknown as TranslationKeys,
  afrikaans: af as unknown as TranslationKeys,
  tagalog: tl as unknown as TranslationKeys,
  turkish: tr as unknown as TranslationKeys,
  arabic: ar as unknown as TranslationKeys,
};

export const supportedLanguages = [
  "english",
  "french",
  "german",
  "spanish",
  "italian",
  "portuguese",
  "afrikaans",
  "tagalog",
  "turkish",
  "arabic",
] as const;

export const rtlLanguages = ["arabic"] as const; // RTL support for Arabic

export type SupportedLanguage = (typeof supportedLanguages)[number];

export function isSupportedLanguage(lang: string): lang is SupportedLanguage {
  return supportedLanguages.includes(lang as SupportedLanguage);
}

export function isRtlLanguage(lang: string): boolean {
  return rtlLanguages.includes(lang as (typeof rtlLanguages)[number]);
}
